import styled from 'styled-components';
import { Typography } from '../../display/Typography';
import { InputTextArea } from '../../inputs/InputTextArea';

export const Container = styled.div`
  display: flex;
`;

export const ContainerContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.xl}rem 10%;
  width: 100%;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
  }
`;

export const SubContainerLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  max-width: 52.2rem;
`;

export const SubContainerRight = styled.div`
  flex: 1;
  max-width: 90rem;
`;

export const StyledPagination = styled(Typography)`
  position: absolute;
  right: 0;
`;

export const AccidentReportContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StateOfTheRoadContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.l}rem;
  flex-basis: 100%;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
  }
`;

export const StyledInputTextArea = styled(InputTextArea)`
  flex-basis: 100%;
`;

export const ContainerAttention = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxl}rem;
`;

export const ContainerRow = styled.div``;

export const SketchImagesContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  flex-wrap: wrap;
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const SketchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${({ theme }) => theme.spaces.s}rem;
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${({ theme }) => theme.spaces.s}rem;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const ContainerInputLoads = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.s}rem;
`;

/**
 * Hueco de tamaño FIJO para el indicador de carga que sustituye al botón «+»
 * mientras se comprimen fotos.
 *
 * Sin esto la fila se estiraba al añadir (feedback tablet 2026-08-15): el
 * `ButtonIconBackground` mide 3,4 rem y el Loader canónico mide 5 rem, trae
 * `margin: auto` —que dentro de un flex absorbe el espacio libre— y una sombra
 * absoluta a 6 rem. Reservando el mismo hueco que el botón, la lista solo
 * cambia de alto cuando de verdad entra una foto nueva.
 */
export const InlineLoaderSlot = styled.div`
  width: 3.4rem;
  height: 3.4rem;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  & > [role='progressbar'] {
    margin: 0;
    /* 🔴 Sin "flex: 0 0 auto" el hijo se ESTRUJA: por defecto un item de flex
       lleva "flex-shrink: 1", así que sus 5 rem de ANCHO se reducían al hueco
       de 3,4 rem mientras el ALTO seguía a 5 rem — dejaba de ser cuadrado.
       Con esto conserva su tamaño y solo lo reduce el "scale", que sí es
       proporcional: 5 rem × 0,68 = 3,4 rem, el mismo hueco que el botón. */
    flex: 0 0 auto;
    transform: scale(0.68);
  }
`;
